"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledContainer = styled_components_1.default.div `
  font-family: Nimbus Sans Regular;
`;
const StyledOptionsContainer = styled_components_1.default.div `
  display: flex;
`;
const StyledOption = styled_components_1.default.div `
  display: flex;
  margin-right: 16px;
  margin-top: 8px;
  align-items: center;
  cursor: pointer;
  position: relative;
`;
const StyledInput = styled_components_1.default.input `
  opacity: 0;
  position: absolute;
  left: 0px;
`;
const StyledCircle = styled_components_1.default.div `
  height: 16px;
  width: 16px;
  border: 1px solid ${tokens.ColorBrandInteractiveBlue};
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
`;
const StyledInnerCircle = styled_components_1.default.div `
  background-color: ${props => props.checked ? tokens.ColorBrandInteractiveBlue : tokens.ColorWhite000};
  width: 12px;
  height: 12px;
  border-radius: 50%;
`;
class RadioButton extends react_1.Component {
    render() {
        const { label, options, selectedOption, onChange, name } = this.props;
        return (react_1.default.createElement(StyledContainer, null,
            label && react_1.default.createElement("label", null, label),
            react_1.default.createElement(StyledOptionsContainer, null, options.map(option => {
                return (react_1.default.createElement(StyledOption, { key: option.value, id: option.id },
                    react_1.default.createElement(StyledCircle, null,
                        react_1.default.createElement(StyledInnerCircle, { checked: selectedOption.value === option.value })),
                    react_1.default.createElement("label", { style: { marginBottom: "0" } },
                        react_1.default.createElement(StyledInput, { type: "radio", checked: selectedOption.value === option.value, onChange: () => onChange(option), value: option.value, name: name }),
                        option.label)));
            }))));
    }
}
exports.default = RadioButton;
//# sourceMappingURL=RadioButton.js.map